import { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import { getReportByIdApi } from '@intelligence/services/reportService';
import type { IntelligenceReportDataInfo } from '../types';
import { createReportFieldUpdater } from './helpers';
import type { ISearchResponse } from './types';

export const useLatestReports = () => {
  const [reports, setReports] = useState<IntelligenceReportDataInfo[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getReportByIdApi({ order_bys: ['create_time desc'] })
      .then((res: ISearchResponse) => {
        if (cancelled) return;
        const list: IntelligenceReportDataInfo[] = Array.isArray(res?.resource_list)
          ? res.resource_list
          : [];
        const sorted = [...list].sort(
          (a, b) => moment(b.create_time).valueOf() - moment(a.create_time).valueOf(),
        );
        setReports(sorted);
      })
      .catch((err: unknown) => {
        console.error('[ReportSearch] fetch latest reports failed:', err);
        if (!cancelled) setReports([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const updateReportField = useCallback(createReportFieldUpdater(setReports), []);

  return { reports, loading, updateReportField };
};
